// @flow

/* eslint no-undef: 0 */
export enum Partner {
  Nebraska = 'nebraska',
  Alaska = 'alaska',
  Maine = 'maine',
  // eslint-disable-next-line no-undef
  Default = 'default',
};

const NEBRASKA_CODE = "ne", ALASKA_CODE = "ak", MAINE_CODE = "me";

// export function getPartnerCode(partner:Partner):?string{
//   switch(partner){
//     case Partner.Nebraska:
//       return NEBRASKA_CODE;
//     case Partner.Nebraska2021:
//       return NEBRASKA2021_CODE
//     case Partner.Alaska:
//       return "ak";
//     case Partner.Default:
//       return null;
//   }
//   return null;
// }

export function getPartnerByCode(code?:string):Partner{
  switch(code){
    case NEBRASKA_CODE:
      return Partner.Nebraska;
    case ALASKA_CODE:
      return Partner.Alaska;
    case MAINE_CODE:
      return Partner.Maine;
    default:
      return Partner.Default;
  }
}